import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {formValueSelector, change} from "redux-form/immutable";
import Form from "./RegisterWaterPalletForm";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelRegisterWaterPallet} from "../../../actions/InventoryApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "palletId");
  errors = validatePresence(errors, values, "inventorySku");
  errors = validatePresence(errors, values, "inventoryIds");
  return errors.toJS();
}

class RegisterWaterPalletFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let dataToSubmit = {
      palletId: values.get("palletId"),
      inventorySku: values.get("inventorySku"),
      inventoryIds: values.get("inventoryIds").split(",").map(id => id.trim())
    }
  
    return this.props.registerWaterPallet(dataToSubmit)
      .then((response) => {
        if (response.data.registerWaterPallet.errors.length <= 0) {
          this.props.cancelRegisterWaterPallet();
        } else {
          let errors = createValidationErrors(response.data.registerWaterPallet.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleJSON(json) {
    this.props.change("RegisterWaterPalletForm", "palletId", json.palletId || json.pallet_id);
    this.props.change("RegisterWaterPalletForm", "inventorySku", json.inventorySku || json.inventory_sku);
    this.props.change("RegisterWaterPalletForm", "inventoryIds", (json.inventoryIds || json.inventory_ids).join(", "));
  }

  handleCancel() {
    this.props.cancelRegisterWaterPallet();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        onJSON={this.handleJSON.bind(this)}
        />
    )
  }

}


const REGISTER_WATER_PALLET = gql`
  mutation registerWaterPallet($data: RegisterWaterPalletInput!) {
    registerWaterPallet(input: $data) {
      errors { key message }
    }
  }
`

const withQueries = compose(
  graphql(REGISTER_WATER_PALLET, {
    props: ({ mutate }) => ({
      registerWaterPallet: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelRegisterWaterPallet, change})(withQueries(RegisterWaterPalletFormContainer));